import { PriceUtils } from "../../utils/PriceUtils";
import { TBookingPriceData } from "./useBookingCard";

export const PriceDataHelper = class {
  ls: TBookingPriceData[];
  constructor(
    splitedBookings: BookingState[],
    priceOfSingleBookings?: PriceOfSingleBookingDTO[],
  ) {
    this.ls = (priceOfSingleBookings ?? [])
      .map((x, i) => ({
        currentBPrice: x,
        currentBState: splitedBookings[i],
      }))
      .filter((x) => x.currentBState && x.currentBPrice);
  }

  isPass() {
    return this.ls?.some((x) => x.currentBPrice.pakage);
  }

  totalOfBeforeServiceFeeTotalOfOrder(): number {
    return this.ls
      .map((x) => x.currentBPrice.beforeServiceFeeTotalOfOrder ?? 0)
      .reduce((a, b) => a + b, 0);
  }

  totalOfCartTotal(): number {
    return this.ls
      .map((x) => x.currentBPrice.cartTotal ?? 0)
      .reduce((a, b) => a + b, 0);
  }
  totalOfpassExtraOptionTotalAmount(): number {
    return this.ls
      .map((x) => x.currentBPrice.passExtraOptionTotalAmount ?? 0)
      .reduce((a, b) => a + b, 0);
  }
  totalOf(t: TPriceItem): number {
    return this.ls
      .map((x) => {
        return PriceUtils.findPriceItem(x.currentBPrice, t)?.actualAmount ?? 0;
      })
      .reduce((a, b) => a + b, 0);
  }

  calcInvidualTotal(): number {
    // giá mua lẻ từng sản phẩm để so sáng với pass
    return (
      this.totalOf("AFTER_DISCOUNT_AND_VOUCHER_TOTAL") -
      this.totalOfpassExtraOptionTotalAmount()
    );
  }
};
